import React from "react";

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    const isChunkLoadError =
      error?.message?.includes("Loading chunk") ||
      error?.message?.includes("ChunkLoadError") ||
      error?.name === "ChunkLoadError";

    return { hasError: true, isChunkLoadError };
  }

  componentDidCatch(error, errorInfo) {
    const isChunkLoadError =
      error?.message?.includes("Loading chunk") ||
      error?.message?.includes("ChunkLoadError") ||
      error?.name === "ChunkLoadError";

    const hasReloaded = sessionStorage.getItem("chunk_failed_reload");

    if (isChunkLoadError && !hasReloaded) {
      sessionStorage.setItem("chunk_failed_reload", "true");
      console.warn("Stale JS bundle detected after deployment. Automatically reloading...");
      window.location.reload();
    } else {
      console.error("ErrorBoundary caught an error:", error, errorInfo);
    }
  }

  componentDidMount() {
    sessionStorage.removeItem("chunk_failed_reload");
  }

  handleManualReload = () => {
    sessionStorage.removeItem("chunk_failed_reload");
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const hasReloaded = sessionStorage.getItem("chunk_failed_reload");
      if (hasReloaded && this.state.isChunkLoadError) {
        return (
          <div
            style={{
              minHeight: "60vh",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              padding: "20px",
              fontFamily: "sans-serif",
            }}
          >
            <h4 style={{ color: "#2E3B52", marginBottom: "12px", fontWeight: "600" }}>
              New Version Available
            </h4>
            <p style={{ color: "#6C7A91", marginBottom: "24px", maxWidth: "420px" }}>
              We have released a new update. Please refresh the page to load the latest features.
            </p>
            <button
              onClick={this.handleManualReload}
              style={{
                padding: "10px 24px",
                background: "#D61F7F",
                color: "#ffffff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "600",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(214, 31, 127, 0.25)",
              }}
            >
              Refresh Page
            </button>
          </div>
        );
      }
    }

    return this.props.children;
  }
}

export default ChunkErrorBoundary;
